import { UserEntity } from "@/modules/profile/userProfile/userEntity"
import type { ScoreDto, SessionScoreDto } from "@/modules/scores/scoreboard/gateway/scoreboardDto"
import { ScoreboardScoreEntity } from "@/modules/scores/scoreForms/entities/scoreboardScoreEntity"
import type { ScoreType } from "@/modules/scores/scoreTypes"
import type { ExerciseCategory } from "@/modules/sessions/sessionDetails/blocks/exerciseBlock/exerciseTypes"

export class ScoreEntity {
  score: ScoreboardScoreEntity | null
  scoreType: ScoreType
  exerciseId: string
  exerciseCategory: ExerciseCategory
  otherCategory: string | null
  orderIndex: number

  constructor(score: ScoreEntity) {
    this.score = score.score
    this.scoreType = score.scoreType
    this.exerciseId = score.exerciseId
    this.exerciseCategory = score.exerciseCategory
    this.otherCategory = score.otherCategory
    this.orderIndex = score.orderIndex
  }

  static fromDto(dto: ScoreDto): ScoreEntity {
    return new ScoreEntity({
      score: dto.score ? ScoreboardScoreEntity.fromDto(dto.score) : null,
      scoreType: dto.scoreType,
      exerciseId: dto.exerciseId,
      exerciseCategory: dto.exerciseCategory,
      otherCategory: dto.otherCategory,
      orderIndex: dto.orderIndex,
    })
  }
}

export class SessionScoreEntity {
  user: UserEntity | null
  scores: ScoreEntity[]

  constructor(sessionScore: SessionScoreEntity) {
    this.user = sessionScore.user
    this.scores = sessionScore.scores
  }

  static fromDto(dto: SessionScoreDto): SessionScoreEntity {
    return new SessionScoreEntity({
      user: dto.user ? UserEntity.fromDto(dto.user) : null,
      scores: dto.scores.map((score) => ScoreEntity.fromDto(score)),
    })
  }
}
